/**
 * Normalizes group/community context from posts or events.
 */
function normalizeCommunities(communities, community) {
  if (communities?.length) {
    return communities;
  }
  if (community) {
    return [community];
  }
  return [];
}

export default normalizeCommunities;
